import { IoArrowForward } from 'react-icons/io5';

import { LoginButton, LoginButtonProps } from 'components/header/components/LoginButton';

import cx from './StartForFreeButton.module.scss';

const StartForFreeButton = (props: LoginButtonProps) => {
    return (
        <LoginButton
            label="Start for free"
            rightSection={<IoArrowForward />}
            leftSection={undefined}
            variant="filled"
            iconOnMobile={false}
            className={cx.root}
            {...props}
        />
    );
};

export { StartForFreeButton };
